// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionView_container__fugic","closePanel":"SubscriptionView_closePanel__2099k","closeIcon":"SubscriptionView_closeIcon__2DGKA"};